import { GroupErrorCodes } from './GroupErrorCodes';

export function groupNotFound(code: GroupErrorCodes) {
  return code === GroupErrorCodes.GROUP_404;
}
